export enum GA4EventKey {
    USER_CONTENT_DATA = 'USER_CONTENT_DATA', // index.html head
    TRAFFIC_SOURCE_DATA = 'TRAFFIC_SOURCE_DATA', // index.html head
    INIT = 'INIT',
    FIELD_CLICK = 'FIELD_CLICK',
    FIELD_CLICK_ENTER = 'FIELD_CLICK_ENTER',
    FIELD_VALUE_DELETE = 'FIELD_VALUE_DELETE',
    FIELD_ERROR = 'FIELD_ERROR',
    OFFERS_ELEMENT_CLICK = 'OFFERS_ELEMENT_CLICK',
    OFFER_FILTER_CLICK = 'OFFER_FILTER_CLICK',
    PAYMENT_STEP_ELEMENT_CLICK = 'PAYMENT_STEP_ELEMENT_CLICK',
    STEP_INIT = 'STEP_INIT',
    PAYMENT_INIT = 'PAYMENT_INIT',
    RECALCULATION = 'RECALCULATION',
}
